import React from 'react';
import { getTrackBackground } from 'react-range';

const RangeTrack = (props) => {
  const { min, max, values, children, trackProps } = props;
  const isRtl = document.querySelector('html').getAttribute('dir') === 'rtl'
  const rangeColors = values.length === 1
    ? ["#73777C", "#D6D6D7"]
    : ["#D6D6D7", "#73777C", "#D6D6D7"]

  return (
    <div className="track-wrap">
      <div
        {...trackProps}
        className="track-line"
        style={{
          ...trackProps.style,
          background: getTrackBackground({
            values,
            colors: rangeColors,
            min,
            max,
            rtl: isRtl
          })
        }}
      >
        {children}
      </div>
    </div>
  )
}

export default RangeTrack;
